module.exports = __webpack_public_path__ + "static/media/701Hou@4x.0d1d076c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/701Hou@4x.png
// module id = 1683
// module chunks = 0 1